(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["category-brands"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', function(event) {
    if (!event.target.matches('[data-category-brand-search]')) return;
    const panel = event.target.closest('.mz-category-brands');
    const query = event.target.value.trim().toLowerCase();
    let visible = 0;
    panel.querySelectorAll('[data-category-brand]').forEach(function(link) {
      link.hidden = !link.dataset.categoryBrand.includes(query);
      if (!link.hidden) visible++;
    });
    panel.querySelector('[data-category-brand-empty]').hidden = visible > 0;
  });
  } catch(e) { console.error(e); }
})();

})();
